import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
    setCheckoutOverlay,
    setShowCalendarInModal,
    setCurrentMonth,
    setShowBestAvailablePicker,
    setShowPyosPicker,
} from "../../../actions/ui";
import {
  getEventTimeFormatted,
    getFormattedEventDates,
    getNumberOfMonths,
    getSeriesOption
} from "../selectors/eventSeries";
import EventSummaryContainer from "../../../containers/EventSummaryContainer";
import SeriesTimePickerContainer from "../containers/SeriesTimePickerContainer"
import MenuDatePickerContainer from '../containers/MenuDatePickerContainer';
import Button from 'shared/Button';
import ChangeDate from '../../ticket-picker/components/ChangeDate';
import SeriesDayPicker from './SeriesDayPicker';
import InventoryFilterContainer from '../containers/InventoryFilterContainer';
import { removeListingItem } from "listing/helpers/storage";
import { createLoadingSelector } from "checkout/selectors/helpers";
import {
    getEventTimes,
    setEventTimes,
    setSelectedDate,
    setSelectedChildEvent,
    selectChildEventAndContinue,
    lazyLoadSeriesDates,
    setChildEventAdditionalInfo,
    changeDateInternal,
} from "../actions/event-series";
import { getSeriesConfig } from "checkout/selectors/ui";
import { navigate } from '../../../helpers/navigationService';
import { isValidDateObject } from "../../../../helpers/time";
import FocusTrap from '@checkout-s/FocusTrap';
import { getInitialFocusSelector } from '../../../helpers/helpers';
import { EMBED_TYPE_CALENDAR } from '../../../reducers/ui';
import { getMainEvent } from '../../../selectors/event';
import Translation from '@checkout-s/Translation';
import EmbedFooter from '../../../components/EmbedFooter';
import { CalendarLegends } from './CalendarLegends';
import { DateTimeFormatters } from '@showclix-shared-intl';
import InventoryItemsContainer from '../../ticket-picker/containers/InventoryItemsContainer';
import CheckoutButton from '../../ticket-picker/containers/CheckoutButton';
import { TranslationContext, withTranslation } from '../../../config/Translations';
import InventoryFooterContainer from '../../ticket-picker/containers/InventoryFooterContainer';
import InventoryErrors from '../../ticket-picker/containers/InventoryErrors';
import FeeDisclosure from '../../ticket-picker/containers/FeeDisclosure';
import CouponEntryButton from '../../ticket-picker/containers/CouponEntryButton';
import { getLoadedListingSlug, isKioskMode } from '../../../selectors/ui';
import SelectLanguage from '../../../../listing/components/SelectLanguage';
import AlertContainer from 'checkout/views/cart/containers/AlertContainer';
import { hasAppliedReserveCoupon, isPyos, isSeatedListing, showPyosPicker } from '@checkout-b/checkout/selectors/reserved-seating';
import BestAvailableOrPyosPicker from '@checkout-v/reserved-seating/containers/BestAvailableOrPyosPicker';
import { revertChildEventSelection } from '@checkout-b/checkout/actions/event';
import clsx from 'clsx';
import { isDynamicListing } from '@checkout-b/checkout/selectors/dynamic-listing';
import { TZDate } from 'react-day-picker';
import MemberAuthButtons from "@checkout/components/MemberAuthButtons";

const { weekDayMonthDayYearShort } = DateTimeFormatters;

const initialFocusClasses = [
  '.series-date-picker .ticket-action__add-button',
  '.series-date-picker .collapsible__button',
  '.series-date-picker .child__event__change-date',
  '.series-date-picker .rdp-button_next:not([disabled])',
  '.series-date-picker .rdp-button_previous:not([disabled])',
  '.series-date-picker .rdp-day_button[tabIndex="0"]',
].join(', ');

class SeriesDatePicker extends PureComponent {
    constructor(props){
        super(props);

        this.state = {
          isChangingDate: false,
          animated: true
        }
    }
    componentDidMount(){
        this.props.onComponentDidMount();
        this.props.setShowPyosPicker(false);
        this.props.setShowBestAvailablePicker(false);

        window.addEventListener('beforeunload', this.props.onUnmount);
    }

    componentWillUnmount() {
      window.removeEventListener('beforeunload', this.props.onUnmount);
    }

    onAnimationEnd = () => {
      this.setState({ animated: true });
    }

    setIsDateChanging = (value) => {
      this.setState({
        isChangingDate: value
      });
      this.props.setShowCalendarInModal(true);
    }

    getContent = () => {
        const dateString = this.props.selectedDayDate && weekDayMonthDayYearShort(this.props.locale, this.props.selectedDayDate);

        const showInventory = this.props.calendarType === 'list'
          ? this.props.selectedChildEvent && !this.state.isChangingDate
          : this.props.selectedChildEvent;

        const {
          isSeated,
          showBestAvailablePicker,
          showPyosPicker,
          eventTimesLoading,
          selectChildEventLoading,
          seriesCalendarLoading,
          isDynamic
        } = this.props;

        return (
            <dialog
              className={`series-date-picker ${this.props.outerClassName}`}
              aria-modal="true"
              tabIndex="-1"
              aria-label={this.props.t('checkout__tickets_for_event', { event_name: this.props.eventName })}
            >
                <div className={clsx('tickets', this.state.animated && 'tickets--no-animation')} onAnimationEnd={this.onAnimationEnd}>
                    {(this.props.headerImage && !this.props.isDynamicListing) && (
                        <div className="tickets__banner-image">
                        <TranslationContext.Consumer>
                            {({ t }) => (
                            <img
                                src={this.props.headerImage}
                                alt={this.props.headerImageAltText || t('checkout__get_tickets_for_event', {
                                eventName: this.props.eventName
                                })}
                            />
                            )}
                        </TranslationContext.Consumer>
                        <div className="header__right">
                            <button onClick={this.props.onClose} className="button--secondary button--close" role="button" ><i className="icon-close" aria-hidden="true"></i><span className="sr-only">Back to event listing.</span></button>
                        </div>
                        </div>
                    )}
                    <div className="tickets__header">
                        {!this.props.headerImage && (
                            <div className="header__right">
                                <button onClick={this.props.onClose} className="button--clear button--close ticket__hide-overlay" role="button" ><i className="icon-close" aria-hidden="true"></i><span className="sr-only">Back to event listing.</span></button>
                            </div>
                        )}
                        <EventSummaryContainer />
                    </div>
                    <AlertContainer />
                    <div className="tickets__content">
                        {!this.props.isKiosk && !isDynamic && <SelectLanguage className='select-language--checkout'/>}
                        {["calendar-button", "calendar-menu", "calendar-list"].includes(this.props.calendarType) && (
                          <div className="tickets__content__list">
                              {!this.props.showChangeDate && (
                                  <Fragment>
                                        {(this.props.inventoryFilter && (!this.props.selectedChildEvent || this.state.isChangingDate)) &&
                                            <div>
                                                <div className="picker__header">
                                                    <h2 className="tickets__inventory-title">
                                                        <Translation>{'checkout__find_tickets'}</Translation>
                                                    </h2>
                                                </div>
                                                <div className="tickets__content__list">
                                                    <InventoryFilterContainer />
                                                </div>
                                            </div>
                                        }
                                        {(this.props.calendarOnListing && !this.props.focusTrap) && <MemberAuthButtons />}
                                        {(!this.props.selectedChildEvent || this.state.isChangingDate) && (
                                            <div className="tickets__datepicker">
                                                <div className="picker__header">
                                                    <i className='icon-calendar' aria-hidden="true" />
                                                    <h3 className="picker__header-title">
                                                        {dateString || <Translation>{'checkout__select_date'}</Translation>}
                                                    </h3>

                                                    {/* <h4 className="picker__header-title">
                                                        {this.props.selectedDayDate
                                                            ? monthDayYearShort(this.props.locale, this.props.selectedDayDate)
                                                            : <Translation>{'checkout__select_date'}</Translation>
                                                        }
                                                    </h4> */}
                                                </div>
                                                {["calendar-button", "calendar-list"].includes(this.props.calendarType) && (
                                                    <CalendarLegends />
                                                )}
                                                <SeriesDayPicker
                                                    selectedDay={this.props.selectedDate}
                                                    onDayClick={this.props.onDayClick}
                                                    onMonthChange={this.props.onMonthChange}
                                                />
                                            </div>
                                        )}
                                    </Fragment>
                                )}
                                {this.props.selectedDate && (
                                    <SeriesTimePickerContainer
                                        selectedDate={this.props.selectedDate}
                                        selectedChildEvent={this.props.selectedChildEvent}
                                        autoFocus={this.props.showChangeDate}
                                        selectedDateDescription={this.props.selectedDateDescription}
                                        isChangingDate={this.state.isChangingDate}
                                        setIsDateChanging={this.setIsDateChanging}
                                        showChangeDate={this.props.showChangeDate}
                                    />
                                )}
                            </div>
                        )}
                        {["menu", "list"].includes(this.props.calendarType) && (
                            <MenuDatePickerContainer
                                eventDates={this.props.eventDates}
                                selectedDay={this.props.calendarType === "calendar-menu" ? this.props.selectedDate : undefined}
                                isDateChaging={this.state.isDateChaging}
                                setIsDateChanging={this.setIsDateChanging}
                                collapsed={this.props.selectedChildEvent && !this.state.isChangingDate}
                                calendarOnListing={this.props.calendarOnListing}
                            />
                        )}
                        {!this.props.isSeated && showInventory && (
                            <div>
                                {/* <div className="picker__header">
                                    <i className='icon-ticket' aria-label='ticket' />
                                    <h4 className="picker__header-title">
                                        <Translation>{'checkout__tickets'}</Translation>
                                        {' '}@ {eventTime}
                                    </h4>
                                </div> */}
                                <InventoryItemsContainer />
                            </div>
                        )}
                        {this.props.selectedDate && this.props.seriesChildAdditionalInfo && this.props.calendarType === "calendar-button"
                            ?
                            <div className="series-child-additional-info message message__inline-banner message--default">
                            <div className="message__icon">
                                <i className="icon-info_outline" aria-hidden="true"></i>
                            </div>
                            <div className="message__text">
                                {this.props.seriesChildAdditionalInfo}
                            </div>
                            </div>
                            :
                            <></>
                        }
                    </div>
                </div>
                <div className="event-inventory__footer-wrap">
                    <div className="event-inventory__footer event-inventory__footer--inline">
                    {this.props.selectedChildEvent && (
                        <div>
                        <InventoryErrors />
                        <FeeDisclosure />
                        {(!this.props.calendarOnListing || this.props.focusTrap) && <MemberAuthButtons />}
                        {(isSeated && (this.props.calendarOnListing || (!showBestAvailablePicker && !showPyosPicker)))
                          ? <BestAvailableOrPyosPicker loading={eventTimesLoading || selectChildEventLoading} />
                          : <CheckoutButton
                              loading={selectChildEventLoading || eventTimesLoading || seriesCalendarLoading}
                            />
                        }
                        <CouponEntryButton />
                        </div>
                    )}
                    {!isDynamic && (<EmbedFooter />)}
                    </div>
                </div>
            </dialog>
        );
    };

    render() {
        if (!this.props.focusTrap) {
            return this.getContent();
        }

        return (
            <FocusTrap
                fallback={'.button--close'}
                focusTrapOptions={{
                  initialFocus: getInitialFocusSelector(initialFocusClasses),
                }}
            >
                {this.getContent()}
            </FocusTrap>
        )
    }
}

SeriesDatePicker.propTypes = {
    onClose: PropTypes.func,
    eventDates: PropTypes.array,
    onDayClick: PropTypes.func,
    onMonthChange: PropTypes.func,
    selectedDateDescription:PropTypes.string,
    focusTrap: PropTypes.bool,
};

SeriesDatePicker.defaultProps = {
    focusTrap: true,
}

const eventTimesLoading = createLoadingSelector("EVENT_TIMES");
const seriesCalendarLoading = createLoadingSelector("SERIES_CALENDAR");
const selectChildEventLoading = createLoadingSelector("SELECT_CHILD_EVENT");
const mapStateToProps = state => {
    const mainEvent = getMainEvent(state);
    return {
        locale: state.intl.locale,
        headerImage: state.ui.uiConfig?.images?.checkoutHeader ?? '',
        headerImageAltText: state.ui.uiConfig?.images?.checkoutHeaderAltText ?? '',
        eventName: state.ui.listingConfig?.listings?.title ?? '',
        listingSlug: getLoadedListingSlug(state),
        isKiosk: isKioskMode(state),
        numberOfMonths: getNumberOfMonths(state),
        eventTimesLoading: eventTimesLoading(state),
        seriesCalendarLoading: seriesCalendarLoading(state),
        selectedDate: state.eventSeries.selectedDate,
        selectedDayDate: state.eventSeries.selectedDateObject,
        eventTimes: state.eventSeries.eventTimes,
        calendarType: getSeriesConfig(state).calendarType,
        selectedChildEvent: state.eventSeries.selectedChildEvent,
        calendarOnListing: !!getSeriesOption("calendarOnListing", false)(state),
        showCalendarInModal: state.ui.showCalendarInModal,
        eventId: getMainEvent(state)?.event?.event_id ?? null,
        eventDates: getFormattedEventDates(state),
        inventoryFilter: getSeriesOption('inventoryFilter')(state) && !getSeriesOption("calendarOnListing", false)(state) && getSeriesOption("calendarType")(state) !== 'list',
        maintenanceMode: state.ui.maintenanceMode,
        isEmbedCalendar: state.ui.embedType == EMBED_TYPE_CALENDAR,
        seriesChildAdditionalInfo: state.eventSeries.seriesChildAdditionalInfo,
        selectedDateDescription: state.eventSeries.selectedDateDescription,
        selectChildEventLoading: selectChildEventLoading(state),
        getEventTimeFormatted: getEventTimeFormatted(state),
        isHeroLayout: state.ui.uiConfig.layout === 'hero',
        isSeated: isSeatedListing(state),
        pyos: isPyos(state),
        showPyosPicker: showPyosPicker(state),
        showBestAvailablePicker: state.ui.showBestAvailablePicker,
        hasAppliedReserveCoupon: hasAppliedReserveCoupon(state),
        prevChildEvent: state.event.prevChildEvent,
        isDynamic: isDynamicListing(state),
        timeZone: mainEvent?.venue?.address?.timezone || '',
        isDynamicListing: isDynamicListing(state),
    };
};

const mapDispatchToProps = dispatch => bindActionCreators(
    {
        setCheckoutOverlay,
        setEventTimes,
        setSelectedDate,
        lazyLoadSeriesDates,
        setShowCalendarInModal,
        setCurrentMonth,
        setSelectedChildEvent,
        selectChildEventAndContinue,
        getEventTimes,
        setChildEventAdditionalInfo,
        setShowBestAvailablePicker,
        setShowPyosPicker,
        revertChildEventSelection,
        changeDateInternal,
    },
    dispatch
);

const mergeProps = (stateProps, dispatchProps, ownProps) => {
    const getSelectedEventTimes = (day) => {
        dispatchProps.getEventTimes(
            stateProps.eventId,
            day
        );
    };

    const showChangeDate = (stateProps.calendarOnListing || stateProps.isEmbedCalendar) && !stateProps.showCalendarInModal;

    return {
        locale: stateProps.locale,
        headerImage: stateProps.headerImage,
        headerImageAltText: stateProps.headerImageAltText,
        eventName: stateProps.eventName,
        eventDates: stateProps.eventDates,
        eventTimes: stateProps.eventTimes,
        calendarType: stateProps.calendarType,
        inventoryFilter: stateProps.inventoryFilter,
        selectedChildEvent: stateProps.selectedChildEvent,
        selectedDate: stateProps.selectedDate,
        selectedDayDate: stateProps.selectedDayDate,
        isHeroLayout: stateProps.isHeroLayout,
        showChangeDate,
        eventTimesLoading: stateProps.eventTimesLoading,
        selectChildEventLoading: stateProps.selectChildEventLoading,
        seriesCalendarLoading: stateProps.seriesCalendarLoading,
        seriesChildAdditionalInfo: stateProps.seriesChildAdditionalInfo,
        calendarOnListing: stateProps.calendarOnListing,
        isSeated: stateProps.isSeated,
        pyos: stateProps.pyos,
        showPyosPicker: stateProps.showPyosPicker,
        showBestAvailablePicker: stateProps.showBestAvailablePicker,
        hasAppliedReserveCoupon: stateProps.hasAppliedReserveCoupon,
        setShowBestAvailablePicker: dispatchProps.setShowBestAvailablePicker,
        setShowPyosPicker: dispatchProps.setShowPyosPicker,
        outerClassName: `tickets--as-overlay tickets-wrap ${
              stateProps.numberOfMonths === 2
                  ? "tickets-wrap__calendar-double"
                  : "tickets-wrap__calendar-single"
        }`,
        selectedDayDescription: stateProps.selectedDayDescription,
        getEventTimeFormatted: stateProps.getEventTimeFormatted,
        isDynamic: stateProps?.isDynamic,
        focusTrap: ownProps?.focusTrap,
        setShowCalendarInModal: dispatchProps.setShowCalendarInModal,
        isDynamicListing: stateProps.isDynamicListing,
        onComponentDidMount: stateProps.selectedDate
            ? () => getSelectedEventTimes(stateProps.selectedDate)
            : () => {
                /**
                 * If this mounts without a selected date for a listing
                 * that shows the calendar on the listing, show the calendar
                 * so the user can pick a date
                 */
                if (showChangeDate && !stateProps.selectedDate) {
                    dispatchProps.setShowCalendarInModal(true);
                }
            },
        onContinue: () => {
          dispatchProps.setChildEventAdditionalInfo(stateProps.seriesChildAdditionalInfo);
          dispatchProps.selectChildEventAndContinue(stateProps.selectedChildEvent);
        },
        onChangeDate: () => {
          dispatchProps.setShowCalendarInModal(true);
          dispatchProps.changeDateInternal();
        },
        onUnmount: () => {
            if (stateProps.prevChildEvent?.event?.event_id) {
              dispatchProps.setSelectedChildEvent(stateProps.prevChildEvent?.event?.event_id);
              dispatchProps.revertChildEventSelection();
            }
        },
        onClose: () => {
            dispatchProps.setCheckoutOverlay(false);
            dispatchProps.setEventTimes([]);
            navigate('/');
            dispatchProps.setChildEventAdditionalInfo("");
            dispatchProps.setSelectedChildEvent(stateProps.prevChildEvent?.event?.event_id);
            dispatchProps.revertChildEventSelection();
        },
        onDayClick: async (day, modifiers = {}) => {
            if (stateProps.eventTimesLoading || modifiers.disabled) {
                return false;
            }

            dispatchProps.setEventTimes([]);
            removeListingItem(stateProps.listingSlug, "selectedEventId");

            //if changing dates after selecting a child event, remove the selected child event
            let selectedDate = new TZDate(stateProps.selectedDate, stateProps.timeZone);
            if (
                isValidDateObject(selectedDate) &&
                selectedDate.toLocaleDateString("en-US") !==
                    day.toLocaleDateString("en-US")
            ) {
                dispatchProps.setSelectedChildEvent(null);
                dispatchProps.setChildEventAdditionalInfo("");
            }

            const newDateString = await dispatchProps.setSelectedDate(day);
            getSelectedEventTimes(newDateString);
        },
        onMonthChange: (inputMonth) => {
            const month = new TZDate(inputMonth.getTime(), stateProps.timeZone);
            dispatchProps.setEventTimes([]);
            removeListingItem(stateProps.listingSlug, "selectedEventId");
            // Can grab the input month to lazy load regardless of timezone
            dispatchProps.lazyLoadSeriesDates(inputMonth);
            // Needs to use the timezone sensitive date object
            dispatchProps.setCurrentMonth(isValidDateObject(month) && month.toISOString ? month.toISOString() : null);
            dispatchProps.setChildEventAdditionalInfo("");
        }
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
    mergeProps,
)(withTranslation(SeriesDatePicker));
